import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BellIcon, DropletIcon, FileBadgeIcon, HomeIcon, IdCardIcon, ScrollTextIcon, Trash2Icon, UserRoundIcon, VolleyballIcon } from 'lucide-react';
import { espaceNav, type EspaceNavItem } from '../../data/espace';
import { useEspace } from '../../contexts/EspaceContext';
const icons: Record<EspaceNavItem['icon'], typeof HomeIcon> = {
  home: HomeIcon,
  card: IdCardIcon,
  profile: UserRoundIcon,
  bell: BellIcon,
  trash: Trash2Icon,
  water: DropletIcon,
  request: ScrollTextIcon,
  ball: VolleyballIcon,
  permit: FileBadgeIcon
};
export function EspaceSidebar() {
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  const {
    exitEspace
  } = useEspace();
  const activeId = espaceNav.find(item => item.to === '/mon-espace' ? pathname === '/mon-espace' : pathname.startsWith(item.to))?.id;
  const leave = () => {
    exitEspace();
    navigate('/');
  };
  return <aside aria-label="Navigation de mon espace" className="hidden w-[268px] shrink-0 flex-col bg-ville-navy lg:flex" data-id="element-1406" data-mp="18714perohpni">
      <div className="px-7 pb-6 pt-8" data-id="element-1407" data-mp="136d3y1dndug3">
        <p className="text-lg font-extrabold tracking-tight text-white" data-id="element-1408" data-mp="y8bm1jryk167">Mon espace</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-1409" data-mp="u6ztb5dsezts">Votre espace citoyen</p>
      </div>

      <nav className="px-3 pb-8" data-id="element-1410" data-mp="u92w6q01gnfx">
        <ul data-id="element-1411" data-mp="1qxsbq9o713yq">
          {espaceNav.slice(0, 3).map(item => <li key={item.id} data-id="element-1412" data-mp="1qzd9071w710a">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1413" data-mp="1lxntof7n016e" />
            </li>)}
        </ul>

        <hr className="my-4 border-white/15" data-id="element-1414" data-mp="1h6nvl6ms7d2b" />

        <ul data-id="element-1415" data-mp="1h5crt6tc65b7">
          {espaceNav.slice(3).map(item => <li key={item.id} data-id="element-1416" data-mp="1d4szqhnmdrvx">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1417" data-mp="1d3rl637ean9g" />
            </li>)}
        </ul>
      </nav>

      <button type="button" onClick={leave} className="mt-auto flex items-center gap-2 px-7 pb-8 text-sm font-semibold text-white/60 transition-colors duration-150 ease-ville hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1418" data-mp="24x1t3co4y44a">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1419" data-mp="80f8da93nh4m" />
        Quitter mon espace
      </button>
    </aside>;
}
function SidebarLink({
  item,
  active
}: {
  item: EspaceNavItem;
  active: boolean;
}) {
  const Icon = icons[item.icon];
  return <Link to={item.to} aria-current={active ? 'page' : undefined} className={`flex items-center gap-3.5 rounded-xl px-4 py-3 text-[15px] font-semibold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-white/10 text-white' : 'text-white/75 hover:bg-white/5 hover:text-white'}`} data-id="element-1420" data-mp="3gdcprxfujxvn">
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-1421" data-mp="14olha9d20vop" />
      {item.label}
    </Link>;
}